module.exports = __webpack_public_path__ + "img/scratch.dd9a1d01.svg";